/**
 * Handles setting container to even width to prevent font pixelation in chrome/safari
 * @module dropdown enter
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
// Expose the function as a jQuery plugin for ease of uses
export const PLUGIN_NAME = 'dropdownEnter';
export const DEFAULTS = {};

function dropdownOnEnter(evt) {
  var $dropdownLink = $(this);

  // Check if width has been previously set
  if($(this).data("setWidth") === true) {
    return;
  }

  var $dropdownMenus = $dropdownLink.find(".dropdown__menu");

  // Set a width for each dropdown menu in dropdown link
  $.each($dropdownMenus, function(index, value) {
    var $dropdownMenu = $(this);
    var width = $dropdownMenu.width();

    if(width % 2 === 1) {
      width += 1;
      $dropdownMenu.width(width);
    }

    $(this).data("setWidth", true);
  });
}

function setEventListeners($el, opts) {
  $el.on("mouseenter", dropdownOnEnter);
}

/**
 * Initializes dropdownEnter.
 * @param {HTMLElement} el - button /element that opens dropdown menu
 * @param {Object} options - Options used for wiring up the dropdownEnter
 * @see DEFAULTS
 */
export default function dropdownEnter(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, dropdownEnter);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/dropdown-enter.js